import { DecisionReason, InAppMessage, InAppMessageContextMessage, List, Properties } from "../../../../model/model"
import { EvaluatorContext, EvaluatorEvaluation } from "../../Evaluator"
import { InAppMessageLayoutRequest } from "./InAppMessageLayoutRequest"

export class InAppMessageLayoutEvaluation implements EvaluatorEvaluation {
  constructor(
    public readonly request: InAppMessageLayoutRequest,
    public readonly reason: string,
    public readonly targetEvaluations: List<EvaluatorEvaluation>,
    public readonly message: InAppMessageContextMessage,
    public readonly properties: Properties
  ) {}

  get inAppMessage(): InAppMessage {
    return this.request.inAppMessage
  }

  static of(
    request: InAppMessageLayoutRequest,
    context: EvaluatorContext,
    message: InAppMessageContextMessage
  ): InAppMessageLayoutEvaluation {
    return new InAppMessageLayoutEvaluation(
      request,
      DecisionReason.IN_APP_MESSAGE_TARGET,
      context.targetEvaluations,
      message,
      context.properties
    )
  }
}
